
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reversi",
      function () {
        return require("private-next-pages/reversi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reversi"])
      });
    }
  